<template>
  <div class="relative">
    <ZtTooltip content="Admin" placement="bottom" :disabled="!compact || isOpen">
      <ContextMenuWrapper placement="bottom-end" test-id="header-admin" @is-visible="(val: boolean) => (isOpen = val)">
        <button
          data-testid="header-admin-trigger"
          :class="
            compact
              ? 'flex h-9 w-9 items-center justify-center rounded-md text-zinc-700 transition-colors hover:bg-zinc-100 focus-visible:ring focus-visible:ring-blue-500/50 focus:outline-none dark:text-zinc-300 dark:hover:bg-zinc-800'
              : 'flex items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold text-zinc-700 transition-colors hover:bg-zinc-100 focus-visible:ring focus-visible:ring-blue-500/50 focus:outline-none dark:text-zinc-300 dark:hover:bg-zinc-800'
          "
          :aria-label="compact ? 'Admin' : undefined"
        >
          <Icon name="general.cog" size="base" />
          <template v-if="!compact">
            <span>Admin</span>
            <Icon name="general.chevronDown" size="xs" :class="{ 'rotate-180': isOpen }" class="transition-transform duration-200" />
          </template>
        </button>
        <template #menu>
          <template v-for="(item, idx) in menuItems" :key="`admin-menu-${idx}`">
            <MenuSeparator v-if="item.isSeparator" />
            <MenuLink v-else :href="item.href || '#'">
              {{ item.title }}
            </MenuLink>
          </template>
        </template>
      </ContextMenuWrapper>
    </ZtTooltip>
  </div>
</template>
<script setup lang="ts">
import { ref, toRefs } from 'vue';
import { ContextMenuWrapper, Icon, MenuLink, MenuSeparator } from '@/storybook';
import { ZtTooltip } from '@/storybook/tooltip';
import { useAdminMenu } from '@/composables/useAdminMenu';

const props = withDefaults(
  defineProps<{
    compact?: boolean;
  }>(),
  { compact: false }
);
const { compact } = toRefs(props);

const { menuItems } = useAdminMenu();
const isOpen = ref(false);
</script>
